export default "__VITE_ASSET__DI0dSS$c__"